import { useMemo } from 'react';
import { AccountStatus, useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { INVESTORS } from '@/common/paths';

import { InvestmentPaths, InvestorStatus } from '../investments.types';

export const INVESTOR_GET_QUERY_KEY = 'useInvestorInfo';

export default () => {
  const { data, isSuccess, isError, isLoading } = useQuery(
    [INVESTOR_GET_QUERY_KEY],
    () => api.get(INVESTORS),
    {
      retry: false,
    }
  );

  const formatedData = useMemo(() => {
    const payload = data?.data;

    const isActiveInvestor = (payload?.status as unknown as InvestorStatus) === InvestorStatus.ACTIVE;
    return {
      balance:
        (payload?.account?.equity_value || 0) + (payload?.account?.cash_balance || 0) ||
        payload?.initial_investment_amount,
      // TODO: Check types
      // @ts-ignore
      investorId: `${payload?.account?.investor_id || payload?.investor_id || payload?.id || ''}`,
      status: payload?.status as unknown as InvestorStatus,
      // TODO: Check types
      // @ts-ignore
      investorBalance: payload?.account?.balance,
      toleranceModel:
        payload?.investor_profile?.tolerance_model || payload?.investor_profile?.proposed_tolerance_model,
      investorAccountId: `${payload?.account?.id || ''}`,
      // @ts-ignore
      investorEnrollmentId: `${payload?.account?.account_id || ''}` || `${payload?.account_id || ''}`,
      currentToleranceModel:
        payload?.type === InvestmentPaths.MANAGED ? payload?.investor_profile?.tolerance_model : '',
      type: payload?.type as InvestmentPaths,
      pendingTradesAmount: isActiveInvestor
        ? (payload?.account?.sell_pending_amount || 0) + (payload?.account?.buy_pending_amount || 0)
        : 0,
      investorAccountStatus: payload?.account?.status as unknown as AccountStatus,
      isInvestmentModelSwitching: payload?.investment_model_switching || false,
      cashBalance: payload?.account?.cash_balance || 0,
      equityValue: payload?.account?.equity_value || 0,

      isFullLiquidationInProgress: payload?.full_liquidation_in_progress || false,
      fullLiquidationIds: (payload?.full_liquidation_instrument_ids || []) as number[],
      position: payload?.employment_profile?.position,
      networkTotal: payload?.investor_profile?.networth_total,
      annualIncome: payload?.investor_profile?.annual_income,

      employmentType: payload?.employment_profile?.employment_type,
      broker: payload?.employment_profile?.broker,

      investmentPortfolioBalance:
        (payload?.account?.equity_value || 0) + (payload?.account?.cash_balance || 0),
      isAutomaticInvestmentEnabled: payload?.automatic_investment_enabled,
      externalAccountNumber: payload?.account?.external_number,
      investmentObjectivesType: payload?.investor_profile?.investment_objectives_type,
      investmentExperienceType: payload?.investor_profile?.investment_experience_type,
    };
  }, [data]);
  return {
    data: formatedData,
    isSuccess,
    isError,
    isLoading,
  };
};
